import { useFormikContext } from 'formik'
import { useCallback } from 'react'
import { IImportOwner, ImportUtilityModel } from '../../typings'
import { SalesTeam } from '@user/store/salesTeam/typings'
import {
  ISalesFunnel,
  ISalesFunnelStage,
} from '@user/store/salesFunnel/typings'

export function useDefaultHandlers() {
  const { setValues } = useFormikContext<ImportUtilityModel>()

  const onChangeSalesFunnel = useCallback(
    (salesFunnel: ISalesFunnel) => {
      setValues((v) => ({
        ...v,
        leadFunnelStageName: '',
        leadFunnelStageId: '',
        salesFunnelId: salesFunnel?.id ?? '',
        salesFunnelName: salesFunnel?.name ?? '',
      }))
    },
    [setValues],
  )

  const onChangeOwnerShip = useCallback(
    (value: any) => {
      const owner = value as IImportOwner

      if (owner) {
        setValues((v) => ({
          ...v,
          assigneeId: owner.id,
        }))
      }
    },
    [setValues],
  )

  const onChangeLeadFunnelStage = useCallback(
    (funnelStage: ISalesFunnelStage | null) => {
      if (funnelStage) {
        setValues((v) => ({
          ...v,
          leadFunnelStageId: funnelStage.id,
          leadFunnelStageName: funnelStage.name,
        }))
      }
    },
    [setValues],
  )

  const onChangeSalesTeam = useCallback(
    (salesTeam: SalesTeam) => {
      setValues((v) => ({
        ...v,
        salesTeamName: salesTeam?.name ?? '',
        salesTeamId: salesTeam?.id.toString() ?? '',
        service: null,
      }))
    },
    [setValues],
  )

  return {
    onChangeSalesFunnel,
    onChangeOwnerShip,
    onChangeLeadFunnelStage,
    onChangeSalesTeam,
  }
}
